<template>
  <v-dialog :value="value" @input="$emit('input', $event)" width="60%">
    <v-card v-if="value">
      <v-card-title>Histórico de Potências</v-card-title>
      <v-card-text>
        <line-chart
          v-if="chartData"
          :chart-data="chartData"
          :options="chartOptions"
          :styles="chartStyles"
        ></line-chart>
        <p v-else class="text--secondary text-center my-4">Sem registros de potência.</p>
        <v-simple-table>
          <thead>
            <tr>
              <th>Serial</th>
              <th>Power (dBm)</th>
              <th>Horário</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(item, index) in powers" :key="index">
              <td>{{ item.serial }}</td>
              <td>
                <v-chip :color="powerColor(item.power)" text-color="white" small>
                  {{ item.power }}
                </v-chip>
              </td>
              <td>{{ item.time | formatDate }} {{ item.time | formatTime }}</td>
            </tr>
          </tbody>
        </v-simple-table>
      </v-card-text>
      <v-card-actions>
        <v-btn color="default" @click="$emit('input', false)">Fechar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import LineChart from "./LineChart.js";
export default {
  name: "PowerHistoryDialog",
  components: { LineChart },
  props: {
    value: { type: Boolean, default: false },
    powers: { type: Array, default: function () { return []; } },
    // Limiares de potência óptica (dBm): valores mais negativos são piores.
    warn: { type: Number, default: -25 },
    crit: { type: Number, default: -27 },
  },
  data: () => ({
    chartOptions: {
      responsive: true,
      maintainAspectRatio: false,
      legend: { display: false },
      scales: {
        yAxes: [{ scaleLabel: { display: true, labelString: "dBm" } }],
      },
      tooltips: {
        callbacks: {
          label: function (item) {
            return item.yLabel + " dBm";
          },
        },
      },
    },
    chartStyles: {
      position: "relative",
      height: "300px",
      width: "100%",
    },
  }),
  computed: {
    sortedPowers: function () {
      return this.powers.slice().sort(function (a, b) {
        if (a.time < b.time) return -1;
        if (a.time > b.time) return 1;
        return 0;
      });
    },
    chartData: function () {
      if (!this.powers || this.powers.length === 0) return null;
      var me = this;
      var fd = this.$options.filters.formatDate;
      var ft = this.$options.filters.formatTime;
      return {
        labels: this.sortedPowers.map(function (p) {
          return fd(p.time) + " " + ft(p.time);
        }),
        datasets: [
          {
            label: "Potência",
            borderColor: "#1976D2",
            backgroundColor: "rgba(25, 118, 210, 0.1)",
            fill: false,
            lineTension: 0,
            pointRadius: 4,
            pointBackgroundColor: this.sortedPowers.map(function (p) {
              return me.powerHex(p.power);
            }),
            pointBorderColor: this.sortedPowers.map(function (p) {
              return me.powerHex(p.power);
            }),
            data: this.sortedPowers.map(function (p) {
              return parseFloat(p.power);
            }),
          },
        ],
      };
    },
  },
  methods: {
    powerColor: function (power) {
      var v = parseFloat(power);
      if (isNaN(v)) return "grey";
      if (v <= this.crit) return "error";
      if (v <= this.warn) return "warning";
      return "success";
    },
    powerHex: function (power) {
      var v = parseFloat(power);
      if (isNaN(v)) return "#9E9E9E";
      if (v <= this.crit) return "#FF5252";
      if (v <= this.warn) return "#FB8C00";
      return "#4CAF50";
    },
  },
};
</script>
